<template>
  <BaseModal :modal-id="modalId" :css-classes="cssClasses" title="Zvolte lokalitu">
    <div class="mb-1 mt-2 mb-md-3 mt-md-4">
      <div v-for="loc in locations" :key="loc.regionSlug" class="row mb-2">

        <div class="col-12 mb-1">
          <div class="form-check">
            <input
              @input="toggleRegion(loc)"
              type="checkbox"
              :checked="isRegionChecked(loc)"
              :indeterminate.prop="isRegionIndeterminate(loc)"
              :id="`loc-region-${loc.regionSlug}`"
              class="form-check-input"
            >
            <label class="form-check-label fw-bold" :for="`loc-region-${loc.regionSlug}`">
              {{ loc.region }}
            </label>
          </div>
        </div>

        <FilterCheckbox
          v-for="district in loc.districts"
          :key="district.slug"
          :field-id="`loc-district-${district.slug}`"
          :option="{ id: district.slug, value: district.name, label: district.name, count: counts[district.slug] ?? 0 }"
          :selected-options="selectedOptions"
          @toggled="toggled"
        />

      </div>
    </div>

    <template v-slot:ok-button>
      <button @click="saveAndClose" type="button" class="btn btn-lg btn-gray flex-fill flex-sm-grow-0">Uložit</button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
import FilterCheckbox from '../filter/FilterCheckbox.vue'
import { LOCATIONS } from '../../data/locations.js'

export default {
  name: 'LocationSelectionModal',

  components: { BaseModal, FilterCheckbox },

  emits: ['selected'],

  props: {
    savedOptions: {
      type: Array,
      default: () => [],
    },
    modalId: {
      type: String,
      default: () => `modal-id-${Math.random().toString(36).slice(7)}`,
    },
    cssClasses: {
      type: Array,
      default: () => [],
    },
    counts: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedOptions: [],
      locations: LOCATIONS,
    }
  },

  computed: {
    openModalId() {
      return this.$store.state.ModalStore.openedModalId
    },
  },

  watch: {
    openModalId(value) {
      if (value === this.modalId) {
        this.selectedOptions = [...this.savedOptions]
      }
    },
    savedOptions() {
      this.selectedOptions = [...this.savedOptions]
    },
  },

  methods: {
    toggled(option) {
      const index = this.selectedOptions.findIndex(o => o.id === option.id)
      if (index >= 0) {
        this.selectedOptions.splice(index, 1)
      } else {
        this.selectedOptions.push(option)
      }
    },

    isRegionChecked(loc) {
      return loc.districts.every(d => this.selectedOptions.some(o => o.id === d.slug))
    },

    isRegionIndeterminate(loc) {
      const count = loc.districts.filter(d => this.selectedOptions.some(o => o.id === d.slug)).length
      return count > 0 && count < loc.districts.length
    },

    toggleRegion(loc) {
      if (this.isRegionChecked(loc)) {
        this.selectedOptions = this.selectedOptions.filter(o => !loc.districts.some(d => d.slug === o.id))
      } else {
        loc.districts.forEach(d => {
          if (!this.selectedOptions.some(o => o.id === d.slug)) {
            this.selectedOptions.push({ id: d.slug, value: d.name, label: d.name })
          }
        })
      }
    },

    saveAndClose() {
      this.$emit('selected', this.selectedOptions)
      this.$store.dispatch('ModalStore/closeModal')
    },
  },
}
</script>
